import { render, staticRenderFns } from "./preview_edit.vue?vue&type=template&id=3bc78fd2&scoped=true&"
import script from "./preview_edit.vue?vue&type=script&lang=js&"
export * from "./preview_edit.vue?vue&type=script&lang=js&"
import style0 from "./preview_edit.vue?vue&type=style&index=0&id=3bc78fd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc78fd2",
  null
  
)

export default component.exports